/** NDT method choices for Statement of Work → Pipeline Section creation (Add New Pipeline modal). */
export const NDT_PIPELINE_TYPE_OPTIONS = [
  { value: 'RT', label: 'RT (Radiographic Testing)' },
  { value: 'AUT', label: 'AUT (Automated Ultrasonic Testing)' },
  { value: 'PAUT', label: 'PAUT (Phased Array Ultrasonic Testing)' },
  { value: 'MUT', label: 'MUT (Manual Ultrasonic Testing)' },
];
